import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import { BigHeadline } from "../components/styles/headlines"

const PricingPage = () => (
  <Layout>
    <Seo title="Preise und Leistungen" />
    <section className="container px-6  mx-auto flex justify-center mt-60 mb-20">
      <div className="w-full lg:w-3/4">
        <BigHeadline>Preise & Leistungen</BigHeadline>
        {/************************************************************************************************** Herren*/}
        <details className="mt-8">
          <summary className="border-b-2 border-main pb-3 ">Herren</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarschnitt trocken Herren</p>
            <p className="ml-2">28,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarschnitt Waschen Herren</p>
            <p className="ml-2">29,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Herrenpaket Deluxe <br />
              (Waschen, Schneiden, Waschen, Kopfmassage 10 min, Styling)
            </p>
            <p className="ml-2">50,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Herren Color Paket <br />
              (Waschen, Schneiden, Föhnen, Färben, Styling)
            </p>
            <p className="ml-2">70,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Bart und Haarkonturen/Bartkonturen</p>
            <p className="ml-2">nach Aufwand</p>
          </div>
        </details>
        {/************************************************************************************************** Damen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Damen</summary>
          
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarschnitt Waschen Föhnen Damen</p>
            <p className="ml-2">67,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarschnitt Damen Spitzen (20 min)</p>
            <p className="ml-2">35,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Waschen Föhnen Damen kurz</p>
            <p className="ml-2">25,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Waschen Föhnen Damen mittel</p>
            <p className="ml-2">35,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Waschen Föhnen Damen lang</p>
            <p className="ml-2">45,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Waschen Schneiden Föhnen Damen kurz/mittel</p>
            <p className="ml-2">51,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Waschen Schneiden Föhnen Damen lang</p>
            <p className="ml-2">61,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Color Damen kurz <br />
              (Waschen, Schneiden, Pflegen, Längenausgleich, Ansatzfarbe, Styling)
            </p>
            <p className="ml-2">105,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Color Damen mittel <br />
              (Waschen, Schneiden, Pflegen, Längenausgleich, Ansatzfarbe, Styling)
            </p>
            <p className="ml-2">117,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Color Damen lang <br />
              (Waschen, Schneiden, Pflegen, Längenausgleich, Ansatzfarbe, Styling)
            </p>
            <p className="ml-2">137,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung New Color Damen kurz <br />
              (Waschen, Schneiden, Pflegen, Ansatzfarbe Länge und Spitze, Styling)
            </p>
            <p className="ml-2">117,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung New Color Damen mittel <br />
              (Waschen, Schneiden, Pflegen, Ansatzfarbe Länge und Spitze, Styling)
            </p>
            <p className="ml-2">132,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Grundpaket New Color Damen lang <br />
              (Waschen, Schneiden, Pflegen, Ansatzfarbe Länge und Spitze, Styling)
            </p>
            <p className="ml-2">145,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Balayage All inklusiv kurz <br />
              (WSF, Pflege, Plex, glossing/Pastel, ggf. Ansatzfarbe Styling, 2-2,5 Std)
            </p>
            <p className="ml-2">175,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Balayage All inklusive mittel <br />
              (WSF, Pflege, Plex, glossing/Pastel, ggf. Ansatzfarbe Styling, Heimpflegeberatung, 3 Std)
            </p>
            <p className="ml-2">247,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Balayage All inklusive lang <br />
              (WSF, Pflege, Plex, glossing/Pastel, ggf. Ansatzfarbe Styling, Heimpflegeberatung, 3 Std)
            </p>
            <p className="ml-2">289,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Balayage Neuauflage</p>
            <p className="ml-2">325,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket gesundes Haar Plex (Haaraufbau + Föhnen) kurz
            </p>
            <p className="ml-2">40,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket gesundes Haar Plex (Haaraufbau + Föhnen) mittel
            </p>
            <p className="ml-2">44,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket gesundes Haar Plex (Haaraufbau + Föhnen) lang
            </p>
            <p className="ml-2">58,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Hochsteckfrisur Deluxe</p>
            <p className="ml-2">275,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Sonstige Steckfrisuren</p>
            <p>Preis nach Absprache</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Dauerwellenpaket kurz/mittel <br/>
              all inkl. Paket (WSF, Pflege, DW, Styling)
            </p>
            <p className="ml-2">102,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Dauerwellenpaket lang <br />
              all inkl. Paket (WSF, Pfleg, DW, Styling)
            </p>
            <p className="ml-2">131,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Dauerwellen Premiumpaket <br />
              mit Vorbehandlung und Plex kurz/mittel
            </p>
            <p className="ml-2">118,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Dauerwellen Premiumpaket <br />
              mit Vorbehandlung und Plex lang
            </p>
            <p className="ml-2">165,00€</p>
          </div>

          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Calligraphy Cut</p>
            <p className="ml-2">20,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Cellophanes</p>
            <p className="ml-2">37,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Kinder*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">
            Kinder
          </summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Kinderhaarschnitte 0-8 mit Waschen</p>
            <p className="ml-2">21,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Kinderhaarschnitte 9-11 mit Waschen</p>
            <p className="ml-2">26,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Kinderhaarschnitte mit Waschen & Föhnen</p>
            <p className="ml-2">29,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Strähnen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">
            Strähnen
          </summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Foliensträhnen/Painting kurz <br />
              (WSF. Pflege, Clossing, Styling, Heimpflegeberatung ganzer Kopf)
            </p>
            <p className="ml-2">143,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Foliensträhnen/Painting mittel <br />
              (WSF. Pflege, Clossing, Styling, Heimpflegeperatung ganzer Kopf)
            </p>
            <p className="ml-2">170,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Topleistung Foliensträhnen/Painting lang <br />
              (WSF. Pflege, Clossing, Styling, Heimpflegeberatung ganzer Kopf)
            </p>
            <p className="ml-2">181,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Folien Oberkopf (Scheitel)</p>
            <p className="ml-2">70,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Folien halber Kopf (Scheitel + Konturen)</p>
            <p className="ml-2">85,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Folien ganzer Kopf</p>
            <p className="ml-2">115,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">einzelne Folie</p>
            <p className="ml-2">7,00€ pro Folie</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Highlights 10 Folien</p>
            <p className="ml-2">45,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Augen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Augen</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Wimpern färben</p>
            <p className="ml-2">15,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Augenbrauen färben</p>
            <p className="ml-2">12,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Augenbrauen zupfen</p>
            <p className="ml-2">11,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Wimpernlifting</p>
            <p className="ml-2">54,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Augenbrauenlifting</p>
            <p className="ml-2">41,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket Schöne Augen 1 <br />
              (Zupfen, Färben Augenbrauen und Wimpern)
            </p>
            <p className="ml-2">24,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket Schöne Augen 2 <br />
              (Wimpernwelle, Augebrauenlifting)
            </p>
            <p className="ml-2">47,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Paket Schöne Augen 3 <br />
              (Zupfen, Lifting, Wimpernwelle, Färben Augenbrauen und Wimpern)
            </p>
            <p className="ml-2">68,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Sonstiges*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">
            Sonstiges
          </summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Clossing/Pastel kurz/mittel/lang</p>
            <p className="ml-2">38,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Tonspülung</p>
            <p className="ml-2">5,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Colorfresh Shampoonierung</p>
            <p className="ml-2">9,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Pony schneiden</p>
            <p className="ml-2">7,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Teilcoloration</p>
            <p className="ml-2">45,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Wellaplex kurz</p>
            <p className="ml-2">27,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Wellaplex mittel</p>
            <p className="ml-2">35,50€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Wellaplex lang</p>
            <p className="ml-2">35,50€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Pflege Conditioner</p>
            <p className="ml-2">11,00€</p>
          </div>
          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarverlängerungen</p>
            <p className="ml-2">Preis nach Absprache</p>
          </div>
        </details>
        {/************************************************************************************************** Hochzeit*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">
            Hochzeit
          </summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">
              Make-up, hochstecken, Probefrisur <br />
              Kooperation mit Roberta Mollame <br />
              Preis nach Absprache{" "}
            </p>
            <a
              href="mailto:brassel.kim@gmx.de?subject=Hochzeitsanfrage%20über%20Website"
              title="Anfragen"
              className="ml-2"
            >
              Anfragen
            </a>
          </div>
        </details>
        {/************************************************************************************************** Nägel*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">
            Nägel
          </summary>

          <div className="flex justify-between pt-5 pb-1 border-b border-main">
            <p className="font-headline">Nägel</p>
            <p className="ml-2">Preis nach Absprache</p>
          </div>
        </details>
      </div>
    </section>
  </Layout>
)

export default PricingPage
